import { render, staticRenderFns } from "./PackageDetails.vue?vue&type=template&id=26673f74&scoped=true"
import script from "./PackageDetails.vue?vue&type=script&lang=ts"
export * from "./PackageDetails.vue?vue&type=script&lang=ts"
import style0 from "./PackageDetails.vue?vue&type=style&index=0&id=26673f74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26673f74",
  null
  
)

export default component.exports